import {createTheme} from "@mui/material";

export const theme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#2b79b8',
            light: '#70b7f0',
            dark: '#015496',
            contrastText: '#c9d5e0'
        },
        secondary: {
            main: '#c4a574'
        },
        background: {
            default: '#efeeeb'
        }
    }
})